import React from "react";


import "./index.scss";


import { Col, Row } from "react-bootstrap";


export type CardTypesType = 'default' | 'badge' | 'explanation';


type CardComponentProps = {
    type: 1 | 2;
    cardType?: 'default' | 'badge' | 'explanation';
    orientation?: "vertical" | "horizontal";
    className?: string;
    children?: React.ReactNode | React.ReactNode[];
    xs?: number; xl?: number;
};


export const CardComponent:React.FC<CardComponentProps> = ({
    children,
    type, cardType = 'default', orientation = "vertical",
    className,
    xs = 12, xl
}) => {

    return (
        <Col xs={xs} xl={xl ?? xs} className={`card-component ${cardType}-card-component orientation-${orientation} type-${type}` + (className ? ` ${className}` : '')}>
            <Row className={`card-component__wrapper ${cardType}-card-component__wrapper` + (className ? ` ${className}__wrapper` : '')}>
                <Col xs={12} className={`card-component__content ${cardType}-card-component__content` + (className ? ` ${className}__content` : '')}>
                    <Row className={`card-component__content__inner-content ${cardType}-card-component__inner-content` + (className ? ` ${className}__content__inner-content` : '')}>
                        {children}
                    </Row>
                </Col>
            </Row>
        </Col>
    );

};


export default CardComponent;
